var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logs"},[_c('v-row',[_c('v-col',{attrs:{"sm":"12"}},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.pageName))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }